import { State } from '../../reducers/rootReducer'
import { CarlineId } from '../../../entities/Carline'

const selectedCarlineIdSelector = (state: State): CarlineId => state.carlineSelection.carlineId

export default selectedCarlineIdSelector
